"use client"

import { useState, useEffect, useCallback } from "react"
import { fetchCostCodes } from "../api/costCodes"

/**
 * Hook to fetch distinct cost code categories for the current user/org.
 * @param {Object} options
 * @param {string} options.token - Auth token
 * @returns {{ categories: string[], loading: boolean, error: string|null, refetch: Function }}
 */
export default function useCostCodeCategories({ token }) {
  const [categories, setCategories] = useState([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  const fetchCategories = useCallback(async () => {
    if (!token) {
      setCategories([])
      return
    }
    setLoading(true)
    setError(null)
    try {
      // Fetch all cost codes and extract unique categories
      const codes = await fetchCostCodes(token, { noPagination: true })
      const cats = Array.from(new Set(codes.map(c => c.category).filter(Boolean)))
      setCategories(cats)
    } catch (err) {
      console.error("Error fetching categories:", err)
      setError(err.message || "Failed to load categories")
    } finally {
      setLoading(false)
    }
  }, [token])

  useEffect(() => {
    fetchCategories()
  }, [fetchCategories])

  return {
    categories,
    loading,
    error,
    refetch: fetchCategories,
  }
}